<template>
  <div class="container mx-auto md:mb-8">
    <div class="buttons flex justify-end mb-4 mr-4 md:mr-0" v-if="$user.isAllowed('create')">
      <router-link :to="{ name: 'user-new' }" class="btn btn-sm bg-green-dark whitespace-no-wrap">
        Nieuwe klant
      </router-link>
    </div>

    <search-input
      class="w-full"
      placeholder="Zoeken op naam.."
      @searched="onSearched">
    </search-input>

    <base-table
      class="bg-white"
      type="user"
      :headers="headers"
      :body="users"
      :sort-key="filters.sort"
      :reversed="filters.reverse"
      :actions="{ editable: $user.isAllowed('update'), removable: $user.isAllowed('destroy') }"
      @ordered="orderChanged">
    </base-table>

    <base-pagination
      v-if="pagination && pagination.last_page > 1"
      class="bg-white"
      :total-pages="pagination.last_page"
      :total="10"
      :current-page="pagination.current_page"
      @page-changed="pageChanged">
    </base-pagination>
  </div>
</template>

<script>
import store from '@/store';
import User from '@/store/modules/user';
import UserPerimeter from '@/perimeters/user';
import SearchInput from '@/components/inputs/Search';

import { mapState } from 'vuex';

if (!store.state.user) store.registerModule('user', User);

export default {
  name: 'UserList',
  perimeters: [UserPerimeter],
  components: {
    SearchInput
  },
  data() {
    return {
      headers: [
        { label: 'Naam', value: 'name', order: true },
        { label: 'Email', value: 'email', order: true }
      ]
    };
  },
  created() {
    this.fetch();
  },
  computed: {
    ...mapState('user', {
      pagination: state => state.pagination,
      users: state => state.items,
      filters: state => state.filters
    })
  },
  methods: {
    pageChanged(page) {
      this.$store.commit('user/setFilters', { key: 'page', value: page });
      this.fetch();
    },
    orderChanged(key) {
      const reverse =
        this.filters.sort.replace('-', '') == key
          ? !this.filters.reverse
          : false;
      const name = reverse ? `-${key}` : key;

      this.$store.commit('user/setFilters', {
        key: 'reverse',
        value: reverse
      });

      this.$store.commit('user/setFilters', { key: 'sort', value: name });
      this.fetch();
    },
    fetch() {
      this.$store.dispatch('user/fetchAll');
    },
    onSearched(keyword) {
      if (!keyword) {
        return this.fetch();
      }
      this.$store.dispatch('user/search', keyword);
    }
  }
};
</script>
